<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="addStockWarehouseModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Dodaj artykuł spoza magazynu</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div  class="table-responsive"
                   style="border-bottom:1px solid #ddd; padding-bottom:20px">

               <!-- <label class="form-label fw-semibold mb-1">Typ dokumentu</label>
                <div class="d-flex gap-3 mb-4">
                  <select v-model="documentType" class="form-select form-select-sm w-auto" style="min-width: 160px">
                    <option v-for="opt in documentTypeOptions" :key="opt" :value="opt">
                      {{ opt.toUpperCase() }}
                    </option>
                  </select>
                  <button type="button"
                          class="btn btn-outline-secondary btn-sm"
                          @click="refreshDocNumber"
                          :disabled="isGeneratingNumber">
                    Odśwież numer
                  </button>
                </div> -->

                <div class="w-100 d-flex align-items-center gap-3 flex-wrap">
                  <h5 class="mb-0">Lista wybranych artykułów</h5>
                </div>

                <h6 class="mt-1">Wybrane pozycje będą przypisane do dokumentu:
                  {{ documentNumber ?? 'generowanie numeru...' }}</h6>
                <table class="table table-striped mt-5">
                  <thead>
                  <tr>
                    <th></th>
                    <th>#</th>
                    <th>Nr Katalogowy</th>
                    <th>Model</th>
                    <th>J.m.</th>
                    <th>Nazwa/Opis</th>
                    <th>Producent</th>
                    <th>Ilość przyjmowana</th>
                    <th>Cena netto PLN</th>
                    <th>Lokalizacja</th>
                    <th>Uwagi</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="article in selectedArticles">
                    <td>
                      <button @click="removeFromSelectedArticles(article.id)" class="btn btn-outline-danger btn-xs">
                        Usuń
                      </button>
                    </td>
                    <td>{{ article.id }}</td>
                    <td>{{ article.catalog_number }}</td>
                    <td>{{ article.model }}</td>
                    <td>{{ article.article_unit.name }}</td>
                    <td>{{ article.description }}</td>
                    <td>{{ article.producer_id?.short_name }}</td>
                    <td class="cell-editable">
                     <!-- <input type="number" step="0.01" min="0.01" v-model="article.quantity_added"
                             class="form-control form-control-sm"/> -->
							 
<input
  type="number"
  :step="isIntegerUnit(article.article_unit.name) ? 1 : 0.01"
  min="0.01"
  v-model.number="article.quantity_added"
  @input="onIntegerInput(article, $event)"
  @keydown="blockNonNumeric($event, article.article_unit.name)"
  class="form-control form-control-sm"
/>
							 
                    </td>
<td class="cell-editable">
<input type="number" step="0.01" min="0.01" v-model="article.price_netto_zl" class="form-control form-control-sm"/>
</td>
                    <td class="cell-editable">
                      <input type="text" v-model="article.location" class="form-control form-control-sm"/>
                    </td>					
                    <td class="cell-editable">
                      <input type="text" v-model="article.comments" class="form-control form-control-sm"/>
                    </td>
                  </tr>
                  </tbody>
                </table>

<div v-if="this.selectedArticles.length" class="mt-3">
  <button
    v-if="canSubmitStock"
    type="button"
    class="btn btn-primary"
    @click="saveSelectedPositions"
    :disabled="isSubmiting"
  >
    Dodaj wybrane pozycje
  </button>

  <div v-else class="alert alert-warning">
    Przyjmowana ilość musi być większa lub równa 1.
  </div>
</div>
              </div>

              <h5 class="pt-4 pb-2">Lista artykułów</h5>
              <ejs-grid ref="addStockWarehouseGrid" id="addStockWarehouseGrid" height="500px"
                        :dataSource="articlesDataManager"
                        :allowTextWrap='false'
                        :allowExcelExport='false'
                        :allowPaging="true"
                        :allowSorting='true'
                        :allowFiltering='true'
                        :allowReordering='true'
                        :allowResizing='true'
                        :showColumnChooser='true'
                        :allowSelection='true'
                        :enablePersistence='true'
                        :pageSettings="pageSettings"
                        :editSettings="editSettings"
                        :filterSettings="filterOptions"
                        :toolbar="toolbar"
                        :selectionSettings="selectionOptions"
                        :actionBegin="actionBegin"
                        :actionComplete="actionComplete"
                        :toolbarClick="clickToolbarHandler">
                <e-columns>
                  <e-column headerText="Dodaj" width="80" :template="'addTemplate'" textAlign="Center"></e-column>
                  <e-column field="id" headerText="ID" width="100" :isPrimaryKey="true" :visible="false"
                            :allowEditing="false"/>
                  <e-column field="photos" headerText="Zdjęcia" width="150" :template="'imageTemplate'"
                            :allowEditing="false" :allowFiltering="false" :allowSorting="false"></e-column>
                  <e-column field="catalog_number" headerText="Nr katalogowy" width="150" :filter="filterDefault"
                            :allowEditing="false"/>
                  <e-column field="model" headerText="Model" width="150" :filter="filterDefault"
                            :allowEditing="false"/>
                  <e-column field="description" headerText="Nazwa/Opis" :defaultValue="null" width="200"
                            :filter="filterDefault" :allowEditing="false"/>
				  <e-column field="article_unit.name" headerText="J.m." width="150" editType="dropdownedit" :filter='filterUnits' :allowEditing="false"/>
                  <e-column field="available_items.quantity" headerText="Ilość/Stany magazynowe" width="150"
                            format="N2" :filter="filterNumeric" type="string" :allowEditing="false"/>
                  <e-column field="price_netto_zl" headerText="Cena Netto zł" width="150" format="N2"
                            type="number" :filter="filterDefault"></e-column>							
                  <e-column field="location" headerText="Lokalizacja" :defaultValue="null" width="200"
                            :filter="filterDefault" :allowEditing="false"/>
                  <e-column field="producer_name" headerText="Producent" :allowEditing="false" :dataSource="producers" :allowSorting="false" :allowFiltering="false"/>
                  <e-column field="price_netto_zl" headerText="Wartość Netto Zł" type="number"
                            :allowEditing="false"
                            :allowSorting="false"
                            :allowFiltering="false" :template="'valueTemplate'"></e-column>
							
				  <e-column field="link" headerText="Link" :defaultValue="null" :filter="filterDefault"
                            :template="'linkTemplate'" :allowEditing="false"/>

                  <e-column field="suppliers_short_names" headerText="Dostawcy"  :allowEditing="false" :dataSource="suppliers" :allowSorting="false" :allowFiltering="false"/>
                </e-columns>
<template v-slot:valueTemplate="{ data }">
  {{
    !data.available_items?.quantity
      ? ''
      : ((data.price_netto_zl || 0) * data.available_items.quantity)
          .toFixed(2)
          .replace('.', ',')
  }}
</template>
<template v-slot:addTemplate="{ data }">

  <template v-if="isArticleSelected(data.id)">
    <span class="text-success">Wybrano</span>
  </template>

  <template v-else>
    <button
      @click="addToNewItems(data)"
      class="btn btn-xs btn-outline-primary">
      Dodaj
    </button>
  </template>

</template>

                <template v-slot:linkTemplate="{data}">
                  <a class="link link-primary" target="_blank" rel="noopener noreferrer" :href=data.link>{{
                      data.link
                    }}</a>
                </template>

                <template v-slot:imageTemplate="{ data }">
                  <div v-if="data.photos && data.photos.length > 0">
                    <img :src="`/${data.photos[0].photo_path}`" alt="Zdjęcie"
                         style="max-height: 100px; max-width: 150px"/>
                  </div>
                </template>

              </ejs-grid>
			</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

<!-- MINI MODAL ILOŚCI -->
<div class="modal fade" ref="qtyModalRef" tabindex="-1">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">Ilość artykułu</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body" v-if="pendingArticle">

        <label class="form-label">Ilość</label>

        <div class="input-group">

          <input
            type="number"
            class="form-control"
            v-model.number="pendingQuantity"
            :min="isIntegerUnit(pendingArticle.article_unit?.name) ? 1 : 0.01"
            :step="isIntegerUnit(pendingArticle.article_unit?.name) ? 1 : 0.01"
            @keydown="blockNonNumeric($event, pendingArticle.article_unit?.name)"
            @input="onQtyInput()"
          />

          <span class="input-group-text">
            {{ pendingArticle.article_unit?.name || '-' }}
          </span>

        </div>

        <label class="form-label">Cena netto</label>

        <div class="input-group">
          <input type="number" class="form-control" v-model.number="pendingArticle.price_netto_zl" :min="0.01" :step="0.01"/>
          <span class="input-group-text">PLN</span>
        </div>
      <label class="form-label">Lokalizacja</label>

			<input type="text" v-model="pendingArticle.location" class="form-control form-control-sm"/>

       <label class="form-label">Uwagi</label>

			<input type="text" v-model="pendingComments" class="form-control form-control-sm"/>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" data-bs-dismiss="modal">Anuluj</button>

        <button class="btn btn-primary" @click="confirmAdd">
          Dodaj
        </button>
      </div>

    </div>
  </div>
</div>

  </div>

</template>

<script>
import {Modal} from "bootstrap";
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter, ForeignKey,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar,
  RowDD,
  VirtualScroll
} from '@syncfusion/ej2-vue-grids';
import {createElement} from "@syncfusion/ej2-base";
import {DataManager, Predicate, Query, WebMethodAdaptor} from '@syncfusion/ej2-data';
import {DropDownList} from "@syncfusion/ej2-dropdowns";
import {router, usePage} from "@inertiajs/vue3";
import {MultiSelect} from "@syncfusion/ej2-vue-dropdowns";
import {ref} from "vue";

let dropInstanceFilterUnits, delivererElem = ref(null), multiSelectObj = ref(null);

export default {
  components: {
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },

  provide: {
    grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, RowDD, VirtualScroll]
  },

  props: {
    project: Number | String,
    team: Boolean | String,
    units: Object,
    suppliers: Object,
    producers: Object
  },
/*
  watch: {
    documentType() {
      this.refreshDocNumber();
    }
  },
*/
  data() {
    return {
      articlesDataManager: [],
	  editingArticle: null,
addQtyModal: null,
pendingArticle: null,
pendingQuantity: 1,
pendingComments: '',
      modalObj: null,
      selectedArticles: [],
      isSubmiting: false,
      reservingArticles: {},
      documentNumber: null,
      documentType: 'pw',
   //   documentTypeOptions: ['dw', 'mm', 'pw', 'wz', 'rw'],
   //   isGeneratingNumber: false,
      pageSettings: {pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200, 500, 1000]},
      filterOptions: {type: "Menu", operator: 'contains'},
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      filterNumeric: {operator: 'equal'},
      toolbar: this.getToolbar(),
      editSettings: this.getEditSettings(),
      selectionOptions: {checkboxOnly: true, persistSelection: true},
      filterUnits: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.units,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj jednostki',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterSuppliers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.suppliers,
              fields: {text: 'short_name', value: 'short_name'},
              placeholder: 'Szukaj dostawców',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      suppliersParams: {
        create: () => {
          this.delivererElem = document.createElement("input");
          return this.delivererElem;
        },
        read: () => {
          return this.multiSelectObj ? this.multiSelectObj.value.join(",") : "";
        },
        destroy: () => {
          if (this.multiSelectObj) {
            this.multiSelectObj.destroy();
            this.multiSelectObj = null;
          }
        },
        write: (args) => {
          const values = args.rowData.suppliers_short_names || ""; // Zabezpieczenie przed null
          const selectedValues = values ? values.split(",") : [];

          this.multiSelectObj = new MultiSelect({
            value: selectedValues,
            dataSource: this.suppliers,
            fields: {text: "short_name", value: "short_name"},
            placeholder: "Wybierz dostawców",
            mode: "Box",
            allowFiltering: true,
            popupHeight: "200px",
            closePopupOnSelect: false,
          });

          this.multiSelectObj.appendTo(this.delivererElem);
        },
      },
    }
  },

  async mounted() {
  	
    this.modalObj = new Modal(this.$refs.modalEle);
    await this.refreshDocNumber();

	this.addQtyModal = new Modal(this.$refs.qtyModalRef)
  },

  beforeMount() {
    this.getArticles();
  },
  
computed: {
/*
  canSubmitStock() {
    if (this.documentType === 'pw') return true

    return this.selectedArticles.every(a => {
      const q = Number(a.quantity_added)
      return Number.isFinite(q) && q >= 1
    })
  },

  hasInvalidStockQuantity() {
    if (this.documentType === 'pw') return false
    return this.selectedArticles.some(a => {
      const q = Number(a.quantity_added)
      return !Number.isFinite(q) || q < 1
    })
  }
  */
  canSubmitStock() {
  return true
},

hasInvalidStockQuantity() {
  return false
}
},

  methods: {
    getAvailableQuantity(row) {
    if (row.available_items && typeof row.available_items.quantity !== "undefined") {
      return Number(row.available_items.quantity)
    }
    if (typeof row["available_items.quantity"] !== "undefined") {
      return Number(row["available_items.quantity"])
    }

    return 0
  },
  
    isIntegerUnit(unitName) {
    const integerUnits = ['szt.', 'szt', 'kpl']; // jednostki, które wymagają liczb całkowitych
    return integerUnits.includes(unitName.toLowerCase());
  },

  // blokowanie wpisywania znaków, tylko liczby całkowite dla określonych jednostek
  blockNonNumeric(event, unitName) {
    if (this.isIntegerUnit(unitName)) {
      // pozwól tylko cyfrze i backspace, delete, strzałki
      if (!/[0-9]/.test(event.key) && !['Backspace','ArrowLeft','ArrowRight','Delete','Tab'].includes(event.key)) {
        event.preventDefault();
      }
    }
    // dla innych jednostek nie blokujemy nic
  },

  onIntegerInput(article, event) {
    if (this.isIntegerUnit(article.article_unit.name)) {
      // zaokrąglamy w locie, żeby było całkowite
      article.quantity_added = Math.floor(article.quantity_added);
    }
  },
  
    getToolbar() {
      return [
        {text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters'},
        {text: "Lista artykułów", prefixIcon: 'e-table-of-content', id: 'articles_list'},
        {text: "Search", prefixIcon: 'e-search', id: "search", align: 'center'},
        {text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
        {text: 'Odśwież', prefixIcon: 'e-refresh', id: 'refresh', align: 'right'},
		"ColumnChooser"      ]
    },

    getEditSettings() {
      return {
        allowEditing: true,
        allowAdding: false,
        allowDeleting: false,
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch',
        newRowPosition: 'Top',
      };
    },

    async refreshDocNumber() {
      this.documentNumber = null;
      this.documentNumber = await this.generateDocumentNumber();
    },

addToNewItems(rowData) {
  this.pendingArticle = { ...rowData }
  this.pendingQuantity = 1
  this.pendingComments = ''
  this.addQtyModal.show()
},

    removeFromSelectedArticles(articleId) {
      this.selectedArticles = this.selectedArticles.filter(item => item.id !== articleId);
    },

    isArticleSelected(articleId) {
      return this.selectedArticles.some(item => item.id === articleId);
    },

    parseSuppliersString(suppliersString) {
      // Zamiana stringa "a, b, c" na ["a", "b", "c"]
      return suppliersString ? suppliersString.split(',').map(s => s.trim()) : [];
    },

    clickToolbarHandler: async function (args) {
      /**
       * Akcja przy kliknięciu resetowania filtrów
       */
      if (args.item.id === 'reset_filters') {
        this.$refs.addStockWarehouseGrid.clearFiltering();
      }

      /**
       * Akcja przy kliknięciu listy artykułów
       */
      if (args.item.id === 'articles_list') {
        window.open(route('articles.index'), '_blank');
      }

      /**
       * Akcja przy kliknięciu odświeżania tabeli
       */
      if (args.item.id === 'refresh') {
        this.$refs.addStockWarehouseGrid.ej2Instances.refresh();
      }
	  
	  	  if (args?.item.id === 'restore') {
        let grid = this.$refs.addStockWarehouseGrid;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();

        // usuń ?ids=... i/lub ids[]=... z aktualnego adresu
        (function stripIdsFromUrl() {
          try {
            const url = new URL(window.location.href);
            url.searchParams.delete('ids');    // np. ?ids=1,2,3
            url.searchParams.delete('ids[]');  // np. ?ids[]=1&ids[]=2
            history.replaceState(history.state, '', url.toString());
          } catch (e) {
            // fallback dla bardzo starych przeglądarek
            const href = window.location.href;
            const cleaned = href
                .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
                .replace(/[?&]$/, '');
            history.replaceState(history.state, '', cleaned);
          }
        })();

        location.reload();
      }
    },

async saveSelectedPositions() {
  this.isSubmiting = true;

  try {
    await this.saveArticles();
  } finally {
    this.isSubmiting = false;
  }
},


    async getArticles() {
      this.articlesDataManager = new DataManager({
        url: route('articles.get', {
          project: this.selectedProjectId,
          team: this.selectedTeamName,
          without_deleted: true
        }),
        adaptor: new WebMethodAdaptor(),
        batchUrl: route('requiredProjectItems.saveChanges'),
        updateUrl: route('requiredProjectItems.updateChanges'),
        crossDomain: true,
        headers: [
          {'X-CSRF-TOKEN': usePage().props.csrf_token}
        ],
      });
    },
async reloadArticles() {
  const grid = this.$refs.addStockWarehouseGrid.ej2Instances;

  grid.dataSource = new DataManager({
    url: route('articles.get', {
      project: this.selectedProjectId,
      team: this.selectedTeamName,
      without_deleted: true
    }),
    adaptor: new WebMethodAdaptor(),
    crossDomain: true,
    headers: [
      { 'X-CSRF-TOKEN': usePage().props.csrf_token }
    ],
  });

  grid.refresh();
},

    async saveArticles() {
      if (!this.selectedArticles.length) {
        this.$emit("added-error", 'Nie został wybrany żaden artykuł');
        return;
      }

      const payload = {
        selectedItems: this.selectedArticles.map(article => ({
          article_id: article.id,
          quantity_added: article.quantity_added,
          price_netto_zl: article.price_netto_zl,
          comments: article.comments,
          location: article.location,
        })),
        document_type: this.documentType,
        newWarehouse: {id: 1, name: 'Główny'},
        comment: this.comment ?? 'Przyjęcie z zewnątrz',
        purpose: this.purpose ?? null,
        who_issuing: this.whoIssuing ?? null,
        who_receiving: this.whoReceiving ?? null,
        signed_date: this.signedDate ?? null,
        additional_comment: this.pendingComments ?? null,
        fromQuoteRequest: false
      };

      try {
        const response = await axios.post(route("warehouse-movements.store"), {data: payload});

        // zakładamy że backend zwraca np. "Poprawnie zmieniono magazyn..."
        this.$emit("added-success", response.data);

        // resetuj formularz
        this.selectedArticles = [];
        this.$refs.addStockWarehouseGrid.clearSelection();
		this.$emit('data-saved');
		await this.reloadArticles();
        this.hide();

      } catch (error) {
        console.error("Błąd zapisu:", error);
        this.$emit("added-error", error.response?.data?.message || "Wystąpił nieznany błąd.");
      } finally {
        this.isSubmiting = false;
      }
    },

    actionBegin(args) {
      //
      // WYSZUKIWARKA- wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === 'searching') {
        const keys = args.searchString.split(',');
        let flag = true;
        let predicate;

        if (this.$refs.addStockWarehouseGrid.ej2Instances.searchSettings.key !== '') {
          this.values = args.searchString;
          keys.forEach((key) => {
            this.$refs.addStockWarehouseGrid.ej2Instances.getColumns().forEach((col) => {
              if (flag) {
                predicate = new Predicate(col.field, 'contains', key, true);
                flag = false;
              } else {
                let predic = new Predicate(col.field, 'contains', key, true);
                predicate = predicate.or(predic);
              }
            });
          });

          this.$refs.addStockWarehouseGrid.ej2Instances.query = new Query().where(predicate);
          this.$refs.addStockWarehouseGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.addStockWarehouseGrid.ej2Instances.refresh();
        } else {
          this.$refs.addStockWarehouseGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.addStockWarehouseGrid.ej2Instances.refresh();
        }
      }
    },

    actionComplete(args) {
      //
      // WYSZUKIWARKA - wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === "refresh" && this.valueAssign) {
        document.getElementById(
            this.$refs.addStockWarehouseGrid.ej2Instances.element.id + "_searchbar"
        ).value = this.values;
        this.valueAssign = false;
      } else if (
          document.getElementById(
              this.$refs.addStockWarehouseGrid.ej2Instances.element.id + "_searchbar"
          ).value === "" &&
          args.requestType === "refresh" &&
          this.removeQuery
      ) {
        this.$refs.addStockWarehouseGrid.ej2Instances.query = new Query();
        this.removeQuery = false;
        this.$refs.addStockWarehouseGrid.ej2Instances.refresh();
      }
    },

    async generateDocumentNumber() {

      try {
        this.isGeneratingNumber = true;

        const response = await axios.get(
            route('warehouse-movements.generate-document-number-json', {
           //   document_type: this.documentType ?? 'PW',
		   document_type: 'PW',
              order_list_item_id: null,
              oldWarehouse: null,
              newWarehouse: {id: 1, name: "Główny"},
              fromQuoteRequest: false
            })
        );
        return response.data.number; // Zwracanie numeru dokumentu
      } catch (e) {
        console.error(e);
        return null;
      } finally {
        this.isGeneratingNumber = false;
      }
    },
	onQtyInput() {
  if (!this.pendingArticle) return

  if (this.isIntegerUnit(this.pendingArticle.article_unit?.name)) {
    this.pendingQuantity = Math.max(1, Math.floor(this.pendingQuantity || 1))
  }
},
confirmAdd() {

  if (!this.pendingArticle) return

  let qty = this.pendingQuantity

  if (this.isIntegerUnit(this.pendingArticle.article_unit?.name)) {
    qty = Math.max(1, Math.floor(qty))
  } else {
    qty = parseFloat(String(qty).replace(',', '.'))
    if (isNaN(qty) || qty <= 0) qty = 0.01
  }

  const article = {
    ...this.pendingArticle,
    quantity_added: qty,
    comments: this.pendingComments
  }

  this.selectedArticles.push(article)

  this.addQtyModal.hide()
  this.pendingArticle = null
  this.pendingQuantity = 1
},
    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },
  }
}

</script>